"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiCallOneContract = exports.overrideMulticallAddress = void 0;
const ethereum_multicall_1 = require("ethereum-multicall");
const utils_1 = require("ethers/lib/utils");
let multicallAddress = undefined;
function overrideMulticallAddress(address) {
    multicallAddress = address;
}
exports.overrideMulticallAddress = overrideMulticallAddress;
async function multiCallOneContract(contract, calls, blockNumber) {
    const functionToIndex = calls.reduce((prev, current, index) => ({
        ...prev,
        [`${current.function}_${index}`]: index,
    }), {});
    const callContexts = calls.map((call, index) => ({
        reference: `${call.function}_${index}`,
        methodName: call.function,
        methodParameters: call.params,
    }));
    const multiCallContext = {
        reference: "this",
        contractAddress: contract.address,
        abi: contract.interface.fragments.map((fragment) => fragment.format(utils_1.FormatTypes.full)),
        calls: callContexts,
    };
    const multicall = new ethereum_multicall_1.Multicall({
        tryAggregate: true,
        ethersProvider: contract.provider,
        multicallCustomContractAddress: multicallAddress,
    });
    const results = await multicall.call(multiCallContext, { blockNumber });
    const resultsInOrder = new Array(calls.length);
    for (const result of results.results["this"].callsReturnContext) {
        if (!result.success) {
            throw new Error(`Failed to execute method of multicall contract: ${contract.address} method name: ${result.methodName}`);
        }
        const index = functionToIndex[result.reference];
        if (result.decoded) {
            if (result.returnValues.length > 1) {
                throw new Error(`ethereum-multicall returned more then one decoded response, which was unexpected. Fix code.`);
            }
            resultsInOrder[index] = result.returnValues[0];
        }
        else {
            resultsInOrder[index] = contract.interface.decodeFunctionResult(result.methodName, result.returnValues);
        }
    }
    return resultsInOrder;
}
exports.multiCallOneContract = multiCallOneContract;
//# sourceMappingURL=multicall.js.map